import './styles/main.scss'
import 'swiper/css'

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

import ButtonConfig from './scripts/ButtonConfig'
import MobileMenu from './scripts/MobileMenu'
import DesktopFullscreenMenu from './scripts/DesktopFullscreenMenu'
import ScrollElements from './scripts/ScrollElements'
import ScrollToButtons from './scripts/ScrollToButtons'
import CallToAction from './scripts/CallToAction'
import HomeFunctionality from './scripts/HomeFunctionality'
import HomeSlider from './scripts/HomeSlider'
import FeaturedProjects from './scripts/FeaturedProjects'
import ProjectPageFunctionality from './scripts/ProjectPageFunctionality'



const buttonConfig = ButtonConfig()
const mobileMenu = MobileMenu()
const desktopFullscreenMenu = new DesktopFullscreenMenu()
const scrollElements = ScrollElements()
const scrollToButtons = ScrollToButtons()
const callToAction = CallToAction()
const homeFunctionality = HomeFunctionality()
const homeSlider = HomeSlider()
const featuredProjects = FeaturedProjects()
const projectPageFunctionality = ProjectPageFunctionality()